import script from "./addEvent.vue?vue&type=script&setup=true&lang=ts"
export * from "./addEvent.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__